import {sessionState} from 'session/session-state.js';

export const Logout = () => {
  sessionState.logout();
  return null;
};
